<template>
  <div class="a-input" :class="{focused: isFocused, empty: inputTextLength === 0, 'is-error': error}" :style="{ width }">
    <input v-model="inputText" @focus="isFocused = true" @blur="isFocused = false" @keyup.enter="onEnter" autocomplete="off" :type="inputType" />
    <label>{{ appliedLabel }}</label>
    <span v-if="error || (type === 'email' && !isValidEmail(inputText))" class="error">{{ error || 'Email is invalid' }}</span>
    <span v-if="required && !inputTextLength" class="error">{{ requiredMessage }}</span>
  </div>
</template>

<script>
import validation from 'src/services/validation.service'

export default {
  name: 'a-input-pwa',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredLabel: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    type: {
      type: String,
      default: 'text',
    }
  },
  data() {
    return {
      inputText: this.value || '',
      isFocused: false,
    }
  },
  computed: {
    inputTextLength() {
      return this.inputText.length
    },
    requiredMessage() {
      return `${this.label} is required`
    },
    appliedLabel() {
      let label = this.label
      if (this.requiredLabel) {
        label += ' *'
      }
      return label
    },
    inputType() {
      let result = this.type
      if (this.mode === 'password') {
        result = 'password'
      }
      if (result === 'email') return 'text'
      return result
    }
  },
  watch: {
    value(val) {
      this.inputText = val
    },
    inputText(val) {
      this.$emit('input', { value: val, name: this.name })
    },
  },
  methods: {
    onEnter() {
      this.$emit('onEnter')
    },
    isValidEmail (string) {
      if (!string) return true
      return validation.isValidEmail(string)
    }
  },
}
</script>

<style scoped lang="scss">
.a-input {
  display: inline-block;
  position: relative;
}
.a-input::after {
  background-color: #95a1aa;
  content: '';
  position: absolute;
  top: 41px;
  left: 0;
  width: 100%;
  height: 1px;
  transform-origin: center bottom;
  transition: background-color 180ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
}
.a-input.is-error::after {
  background-color: red;
}
.a-input.focused::after {
  background-color: #0381ff;
  transform: translateY(100%) scaleY(2);
}
input {
  font-size: 14px;
  line-height: 1;
  outline: none;
  border: 0;
  padding: 16px 0 8px;
  width: 100%;
  background-color: transparent;
  &:focus {
    outline: none;
  }
}
label {
  color: #95a1aa;
  cursor: text;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  pointer-events: none;
  position: absolute;
  top: 19px;
  left: 0;
  transform-origin: left top;
  transition: color 180ms cubic-bezier(0.4, 0, 0.2, 1),
    transform 180ms cubic-bezier(0.4, 0, 0.2, 1);
}
.focused > label {
  color: #0381ff;
  transform: translateY(-146%) scale(0.92, 0.92);
}
:not(.empty):not(.focused) > label {
  color: #95a1aa;
  transform: translateY(-146%) scale(0.92, 0.92);
}
.error {
  color: red;
  font-size: 12px;
  background: transparent !important;
}
</style>
